import { observable, action, /* computed */ } from 'mobx';

// import { store } from './store.index';
class AppStore {
    @observable templateData = window.__doc_templates__.templates;
    @observable token = null;
    @observable userInfo = {
      email: '', // email

      username: '', // full name

      userid: '',// cUserID
      uuid: '' // device id
    };
    @observable tabIndex = 0;
    @observable disableTrace = false;

    @observable baseUrl = (process.env.NODE_ENV === 'development')?'https://template-azk8s.foxitcloud.com':window.location.origin;
    @observable categories=[]
    @action updateDisableTrace(value){
      this.disableTrace = value;
    }
    @action updateUserInfo = (value)=>{
      this.userInfo = value;
    }
    @action updateTemplate = (arr)=>{
      this.templateData = [];
      this.templateData = arr;
    }
    @action updateCategories=(value)=>{
      this.categories = value
    }
    @action updateTabIndex = (value)=>{
      this.tabIndex = value
    } 
    
}
export default AppStore;